/* eslint-disable no-magic-numbers */
type Coordinate = {
    x: number;
    y: number;
};

type ItemRect = {
    x: number;
    y: number;
    width: number;
    height: number;
};

function getDistanceBetweenCoordinateAndItemBounds(
    referanceCoordinate: Coordinate,
    item: ItemRect
) {
    const dx = Math.max(item.x - referanceCoordinate.x, 0, referanceCoordinate.x - (item.x + item.width));
    const dy = Math.max(item.y - referanceCoordinate.y, 0, referanceCoordinate.y - (item.y + item.height));

    return Math.sqrt(dx * dx + dy * dy);
}

function getDistanceBetweenCoordinateAndItemCenter(
    referanceCoordinate: Coordinate,
    item: ItemRect
) {
    const itemCenterX = item.x + item.width / 2;
    const itemCenterY = item.y + item.height / 2;

    return Math.sqrt(
        Math.pow(itemCenterX - referanceCoordinate.x, 2) +
        Math.pow(itemCenterY - referanceCoordinate.y, 2)
    );
}

function isCoordinateIntersectWithItemBounds(
    referanceCoordinate: Coordinate,
    item: ItemRect,
    proximityThreshold: number
) {
    return getDistanceBetweenCoordinateAndItemBounds(referanceCoordinate, item) <= proximityThreshold;
}

function isCoordinateIntersectWithItemCenter(
    referanceCoordinate: Coordinate,
    item: ItemRect,
    proximityThreshold: number
) {
    return getDistanceBetweenCoordinateAndItemCenter(referanceCoordinate, item) <= proximityThreshold;
}

export {
    getDistanceBetweenCoordinateAndItemBounds,
    getDistanceBetweenCoordinateAndItemCenter,
    isCoordinateIntersectWithItemBounds,
    isCoordinateIntersectWithItemCenter
};
